"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _onlinePort = _interopRequireDefault(require("./componens/onlinePort"));
var _vuex = require("vuex");
var _vue = require("@handsontable/vue");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "billConsigneeApplication",
  components: {
    HotColumn: _vue.HotColumn,
    Pagination: _index2.default,
    billButtons: _billButtons.default,
    filterColumn: _index.default,
    onlinePort: _onlinePort.default
  },
  data: function data() {
    return {
      dataTotal: 0,
      billRules: {
        portCode: [{
          required: true,
          message: this.$t('userCenter.editFormDialog.portCodeRule'),
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: this.$t('userCenter.editFormDialog.companyNameRule'),
          trigger: 'blur'
        }],
        companyNameCn: [{
          required: true,
          message: this.$t('userCenter.editFormDialog.companyNameCnRule'),
          trigger: 'blur'
        }],
        usci: [{
          required: true,
          message: this.$t('userCenter.editFormDialog.usciRule'),
          trigger: 'blur'
        }]
      },
      loading: null,
      editDialog: false,
      dialogType: '',
      tableCostData: [],
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 345px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      billForm: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      },
      searchForm: {
        portCode: '',
        companyName: '',
        companyNameCn: '',
        usci: ''
      },
      userInfo: {},
      selectionIds: [],
      tableDataStutus: [],
      statusValueList: [
        // {
        //   value: 0,
        //   label: '待提交'
        // },
        // {
        //   value: 1,
        //   label: '待审核'
        // },
        // {
        //   value: 2,
        //   label: '已审核'
        // },
        // {
        //   value: 3,
        //   label: '取消审核'
        // }
      ],
      statusValueListEn: [{
        value: 0,
        label: 'To be submitted'
      }, {
        value: 1,
        label: 'Audit'
      }, {
        value: 2,
        label: 'Audited'
      }, {
        value: 3,
        label: 'Cancel audit'
      }],
      isCancelSubmit: false,
      isConfirm: false,
      isCancelDel: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    if (this.language === 'zh') {
      this.statusValueList = [{
        value: 0,
        label: '待提交'
      }, {
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '已审核'
      }, {
        value: 3,
        label: '取消审核'
      }];
    } else {
      this.statusValueList = [{
        value: 0,
        label: 'Waiting to apply'
      }, {
        value: 1,
        label: 'Waiting to approve'
      }, {
        value: 2,
        label: 'Approved'
      }, {
        value: 3,
        label: 'Cancel audit'
      }];
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    console.log('    this.userInfo', this.userInfo);
    this.$nextTick(function () {
      _this.resizeHotTable();
    });
    this.searchFormData();
  },
  watch: {
    tableDataStutus: {
      handler: function handler(val) {
        var i = 0;
        for (i = 0; i < val.length; i++) {
          if (val[i].status == 0) {
            this.isCancelSubmit = true;
            return;
          } else if (val[i].status == 1) {
            this.isCancelDel = true;
            this.isConfirm = true;
            return;
          } else if (val[i].status == 2) {
            this.isCancelSubmit = true;
            this.isCancelDel = true;
            this.isConfirm = true;
            return;
          } else if (val[i].status == 3) {
            this.isCancelSubmit = true;
            return;
          }
        }
        if (i == val.length) {
          this.isCancelSubmit = false;
          this.isCancelDel = false;
          this.isConfirm = false;
        }
      },
      deep: true
    }
  },
  methods: {
    hotTableSelect: function hotTableSelect(data) {
      console.log('data', data);
      var array = [];
      var arrayStatus = [];
      this.$refs.hotTableCost.getSelections().forEach(function (e) {
        array.push(e.blConsigneeCertificationId);
        arrayStatus.push({
          status: e.status
        });
      });
      this.selectionIds = array;
      this.tableDataStutus = arrayStatus;
      console.log('this.selectionIds', this.selectionIds);
      console.log('tableDataStutus', this.tableDataStutus);
    },
    closeDialog: function closeDialog() {
      this.billForm = {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      };
    },
    handleEdit: function handleEdit(row) {
      var data = this.$refs.hotTableCost.getSelected();
      this.dialogType = 'edit';
      this.billForm = JSON.parse(JSON.stringify(data));
      this.editDialog = true;
    },
    handleDel: function handleDel(row) {
      var _this2 = this;
      if (!this.selectionIds.length > 0) {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isSelectData'),
          type: 'warning'
        });
        return;
      }
      console.log('this.isCancelDel', this.isCancelDel);
      if (this.isCancelDel) {
        if (this.selectionIds.length > 1) {
          this.$message({
            message: this.$t('userCenter.billConsigneeApplication.isCancelDelText2'),
            type: 'warning'
          });
          return;
        } else {
          this.$message({
            message: this.$t('userCenter.billConsigneeApplication.isCancelDelText'),
            type: 'warning'
          });
          return;
        }
      }
      this.$confirm(this.$t('userCenter.billConsigneeApplication.deleteConfirm'), '提示', {
        confirmButtonText: this.$t('userCenter.billConsigneeApplication.confirmButton'),
        cancelButtonText: this.$t('userCenter.billConsigneeApplication.cancelButton'),
        type: 'warning'
      }).then(function () {
        _this2.loading = (0, _utils.load)();
        (0, _billConsigneeApplication.deletehWebBlConsigneeCertification)(_this2.selectionIds).then(function (response) {
          if (response.success) {
            _this2.$message({
              message: _this2.$t('userCenter.billConsigneeApplication.deleteMessage'),
              type: 'success'
            });
            _this2.selectionIds = [];
            _this2.tableDataStutus = [];
            _this2.listQuery.currentPage = 1;
            _this2.searchFormData();
          } else {
            _this2.$message({
              message: response.errorMessages[0],
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this2.dialogVisible = false;
        }).finally(function () {
          _this2.loading.close();
        });
      });
    },
    handleConfirm: function handleConfirm(row) {
      var _this3 = this;
      if (!this.selectionIds.length > 0) {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isSelectData'),
          type: 'warning'
        });
        return;
      }
      if (this.isConfirm) {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isConfirmText'),
          type: 'warning'
        });
        return;
      }
      this.loading = (0, _utils.load)();
      (0, _billConsigneeApplication.submithWebBlConsigneeCertification)(this.selectionIds).then(function (response) {
        if (response.success) {
          _this3.$message({
            message: _this3.$t('userCenter.billConsigneeApplication.confirmMessage'),
            type: 'success'
          });
          _this3.listQuery.currentPage = 1;
          _this3.selectionIds = [];
          _this3.tableDataStutus = [];
          _this3.searchFormData();
        } else {
          _this3.$message({
            message: response.errorMessages[0],
            type: 'error'
          });
        }
      }).catch(function (err) {
        console.log(err);
        _this3.dialogVisible = false;
      }).finally(function () {
        _this3.loading.close();
      });
    },
    handleCancelConfirm: function handleCancelConfirm(row) {
      var _this4 = this;
      if (!this.selectionIds.length > 0) {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isSelectData'),
          type: 'warning'
        });
        return;
      }
      if (this.isCancelSubmit) {
        if (this.selectionIds.length > 1) {
          this.$message({
            message: this.$t('userCenter.billConsigneeApplication.isCancenSubmitText2'),
            type: 'warning'
          });
          return;
        } else {
          this.$message({
            message: this.$t('userCenter.billConsigneeApplication.isCancenSubmitText'),
            type: 'warning'
          });
          return;
        }
      }
      this.loading = (0, _utils.load)();
      (0, _billConsigneeApplication.cancelSubmitWebBlConsigneeCertification)(this.selectionIds).then(function (response) {
        if (response.success) {
          _this4.$message({
            message: _this4.$t('userCenter.billConsigneeApplication.cancenConfirmMessage'),
            type: 'success'
          });
          _this4.listQuery.currentPage = 1;
          _this4.selectionIds = [];
          _this4.tableDataStutus = [];
          _this4.searchFormData();
        } else {
          _this4.$message({
            message: response.errorMessages[0],
            type: 'error'
          });
        }
      }).catch(function (err) {
        console.log(err);
        _this4.dialogVisible = false;
      }).finally(function () {
        _this4.loading.close();
      });
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTableCost.resizeTo();
    },
    resetForm: function resetForm() {
      this.searchForm = {
        companyName: '',
        companyNameCn: '',
        usci: ''
      };
    },
    searchFormData: function searchFormData() {
      var _this5 = this;
      this.searchForm.companyName = this.searchForm.companyName.trim();
      this.searchForm.companyNameCn = this.searchForm.companyNameCn.trim();
      this.searchForm.usci = this.searchForm.usci.trim();
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      this.loading = (0, _utils.load)();
      (0, _billConsigneeApplication.searchWebBlConsigneeCertification)(data).then(function (res) {
        _this5.tableCostData = res.data.records;
        _this5.listQuery.total = res.data.totalRecord;
        _this5.selectionIds = [];
        _this5.tableDataStutus = [];
      }).catch(function (err) {
        console.log('err', err);
      }).finally(function () {
        _this5.loading.close();
      });
    },
    saveFormClick: function saveFormClick() {
      var _this6 = this;
      this.$refs.billFormRef.validate(function (valid) {
        if (valid) {
          if (_this6.dialogType == 'add') {
            _this6.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.addWebBlConsigneeCertification)(_this6.billForm).then(function (res) {
              console.log('res', res);
              _this6.editDialog = false;
              _this6.searchFormData();
              _this6.$message({
                message: _this6.$t('userCenter.billConsigneeApplication.addSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
            }).finally(function () {
              _this6.loading.close();
            });
          } else if (_this6.dialogType == 'edit') {
            _this6.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.saveWebBlConsigneeCertification)(_this6.billForm).then(function (res) {
              console.log('res', res);
              _this6.editDialog = false;
              _this6.searchFormData();
              _this6.$message({
                message: _this6.$t('userCenter.billConsigneeApplication.editSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this6.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            }).finally(function () {
              _this6.loading.close();
            });
          }
        } else {
          return false;
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    addClick: function addClick() {
      this.dialogType = 'add';
      this.editDialog = true;
    },
    columnRendererPrint: function columnRendererPrint(instance, td, row, col, prop, value, cellProperties) {
      var _this7 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      link.innerText = value;
      link.addEventListener('click', function () {
        return _this7.handleDownload(row);
      });

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleDownload: function handleDownload(row) {
      var _this8 = this;
      var data = this.$refs.hotTableCost.getSelected();
      if (data.fileId) {
        this.loading = (0, _utils.load)();
        (0, _billConsigneeApplication.setDownloadFile)(data.fileId).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res]));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          console.log('res', res);
          link.setAttribute('download', data.letterOfCommitment);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(function (err) {}).finally(function () {
          _this8.loading.close();
        });
      } else {
        this.loading = (0, _utils.load)();
        (0, _billConsigneeApplication.setDownLoadLetter)(data.letterOfCommitment).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res]));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          console.log('res', res);
          link.setAttribute('download', data.letterOfCommitment);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(function (err) {}).finally(function () {
          _this8.loading.close();
        });
      }
    }
  }
};